import { useEffect, useRef, useState } from 'react';

const PLAYBACK_RATE = 1.35;
const LOGO_HOLD_MS = 4200;
const VIDEO_FALLBACK_MS = 9000;

export default function PhonePreview() {
  const videoRef = useRef(null);
  const [phase, setPhase] = useState('video');

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) setPhase('logo');
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || phase !== 'video') return undefined;
    const resume = () => {
      if (document.hidden || video.ended) return;
      video.play().catch(() => {});
    };
    video.playbackRate = PLAYBACK_RATE;
    video.play().catch(() => {});
    video.addEventListener('pause', resume);
    const timer = setTimeout(() => setPhase('logo'), VIDEO_FALLBACK_MS);
    return () => {
      clearTimeout(timer);
      video.removeEventListener('pause', resume);
    };
  }, [phase]);

  useEffect(() => {
    if (phase !== 'logo') return undefined;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return undefined;
    const timer = setTimeout(() => {
      const video = videoRef.current;
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.playbackRate = PLAYBACK_RATE;
      }
      setPhase('video');
    }, LOGO_HOLD_MS);
    return () => clearTimeout(timer);
  }, [phase]);

  const showLogo = () => setPhase('logo');

  return (
    <div className="gl-phone" aria-label="הדמייה של פתיחת האפליקציה">
      <span className="gl-phone-button gl-phone-button--silent" aria-hidden="true" />
      <span className="gl-phone-button gl-phone-button--up" aria-hidden="true" />
      <span className="gl-phone-button gl-phone-button--down" aria-hidden="true" />
      <div className="gl-phone-screen">
        <span className="gl-phone-island" aria-hidden="true" />
        <div className={`gl-sim-boot${phase === 'video' ? ' is-on' : ''}`}>
          <span className="gl-sim-orb gl-sim-orb--gold" />
          <span className="gl-sim-orb gl-sim-orb--blue" />
          <span className="gl-sim-orb gl-sim-orb--plum" />
          <div className="gl-sim-boot-body">
            <div className="gl-sim-mark">
              <video
                ref={videoRef}
                src="/phone/loadingApp.mp4"
                muted
                playsInline
                preload="auto"
                onEnded={showLogo}
              />
            </div>
            <p>Great Leaders</p>
            <div className="gl-sim-dots" aria-hidden="true">
              <i />
              <i />
              <i />
            </div>
          </div>
        </div>
        <div
          className={`gl-sim-home${phase === 'logo' ? ' is-on' : ''}`}
          style={{ backgroundImage: 'url(/phone/logo-bg.png)' }}
        >
          <img src="/phone/gl-logo.png" alt="" />
          <h3>Great Leaders</h3>
          <p>Take The Lead</p>
          <div className="gl-sim-actions">
            <span>נצא לדרך!</span>
            <span>יש לי כבר משתמש</span>
          </div>
        </div>
        <span className={`gl-phone-home${phase === 'video' ? ' is-dark' : ''}`} aria-hidden="true" />
      </div>
    </div>
  );
}
